





























import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import ImageCropper from "@/components/ImageCropper";
import { CropConfig } from "@/components/ImageCropper/types";
import ModalView from "@/components/ModalView";

export default defineComponent({
  name: "AvatarCropModal",
  components: { ImageCropper, ModalView },
  props: {
    show: { type: Boolean, required: true },
    avatar: { type: String, required: true },
    user: { type: Object as PropType<UserPublicData>, required: true },
    loading: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const cropConfig: CropConfig = {
      exportWidth: 327,
      exportHeight: 327,
      aspectRatio: 1,
      cropZoneWidth: 327,
      cropZoneHeight: 327,
    };

    const handleCropImage = (blob: Blob) => {
      const file = new File([blob], `${props.user.screenName}_avatar.jpg`, { type: "image/jpeg" });
      emit("imageCropped", file);
    };
    return { cropConfig, handleCropImage };
  },
});
